/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-15 11:04:35
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-19 16:27:37
 * @FilePath: \pit-bimwin-react-ui\src\components\pitBimwinDialog\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { FC, CSSProperties, useEffect } from 'react';
import styles from '../../styles/pitBimwinDialog.module.scss';
import { handleMousedown, handleResize, handleResize1 } from './drag';
interface PitBimwinDialogProps {
  visible: boolean;
  className?: string;
  title?: string;
  center?: boolean;
  beforeClose?: Function;
  isResiz?: boolean;
  id?: string;
  children?: any;
  style?: CSSProperties;
}
const PitBimwinDialog: FC<PitBimwinDialogProps> = ({
  id,
  className,
  title,
  children,
  isResiz = true,
  visible,
  beforeClose,
  style,
}) => {
  useEffect(() => {
    console.log('dialog', visible);
    // setIsVisible(() => visible);
  }, [visible]);
  const handleClose = () => {
    beforeClose && !beforeClose();
  };
  // const [isVisible, setIsVisible] = useState(visible);
  return (
    <div
      style={{ display: visible ? 'flex' : 'none', ...style }}
      id={id}
      className={`${className} ${styles['pit-bim-win-dialog']} ${styles['pit-bim-win-dialog-wrapper']}`}
    >
      <div
        className={`${styles['pit-bim-win-dialog-title']}`}
        onMouseDown={(e) => handleMousedown(e)}
      >
        <div style={{ cursor: 'move', userSelect: 'none', fontSize: '16px' }}>
          {title}
        </div>
        <div className={`${styles['pit-close']}`} onClick={handleClose}></div>
      </div>
      <div className={`${styles['flowline']}`}></div>
      <div className={`${styles['pit-bim-win-dialog-body']}`}>{children}</div>
      {isResiz ? (
        <div
          className={`pit-resize`}
          onMouseDown={(e) => handleResize(e)}
        ></div>
      ) : (
        ''
      )}
      {isResiz ? (
        <div
          className={`pit-resize1`}
          onMouseDown={(e) => handleResize1(e)}
        ></div>
      ) : (
        ''
      )}
    </div>
  );
};
PitBimwinDialog.defaultProps = {
  visible: false,
  className: '',
  title: '弹窗',
  center: false,
  isResiz: true,
};
export default PitBimwinDialog;
